import React from "react";

class Head extends React.Component {
  render() {
    return (
        <header style={{
          display: 'flex',
          justifyContent: "space-around",
          backgroundColor: 'transparent',
          minWidth: '100vw',
          padding: '10px'
        }}>
            {this.props.children}
        </header>
    );
  }
}

export default Head;